import cn from 'classnames'
export const popoverContentClassName =
   'border-1 rounded-[8px] flex flex-col w-[240px] py-[6px]'

export const getTriggerStyles = (isOpen: boolean, theme: any): string =>
   cn(
      `flex-shrink-0 cursor-pointer p-[2px] rounded-[4px] ${theme.hoverBgColor}`,
      {
         [theme.menuOpenedStateBgColor]: isOpen
      }
   )
